export default __webpack_public_path__ + "static/media/typeOffroad.6b2cfa8d.6b2cfa8d.svg";